import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {
  showPackageDetails,
  goToPage,
  reportAnalytics,
  setSubscriptionPriceForDisplay,
} from '../PremiumPackagesHolder/PremiumPackagesHolderSlice';
import EpiContext from '@episerver/spa-core/Spa';
import {isMobile} from 'react-device-detect';

const premiumPackage = (props) => {
  const showPackageDetailsHandler = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_13',
      eventLabel: props.data.packageName,
    });
    savePriceToState();
    props.data.isOnlyOneSubscription ? props.goToPage('subscriptionDetails') : props.goToPage('packageDetails');
    props.showPackageDetails({show: true, index: props.idx});
  };

  const savePriceToState = () => {
    if (props.data.isDailySubscriptionIncludes) {
      props.setSubscriptionPriceForDisplay({price: props.data.lowestPrice, text: 'החל מ-'});
    } else {
      props.setSubscriptionPriceForDisplay({price: props.data.price, text: 'לחודש'});
    }
  };

  const whichPriceToShow = () => {
    if (props.data.isDailySubscriptionIncludes) {
      return (
        <div className='package-price-lowest'>
          <span>החל מ-</span>
          <span>₪{props.data.lowestPrice}</span>
        </div>
      );
    } else {
      return (
        <div className='package-price'>
          <span>₪{props.data.lowestPrice}</span>
          <span>לחודש</span>
        </div>
      );
    }
  };

  return (
    <div className='premium-package-container' onClick={() => showPackageDetailsHandler()}>
      <div>
        <Image className='package-background'
          src={EpiContext.getEpiserverUrl(isMobile ? props.data.mobileImage : props.data.desktopImage)}
          alt='תמונה' />
        <div className='package-background-overlay'></div>
      </div>
      <div className='package-title'>
        <span className='package-name'>{props.data.packageName}</span>
        {whichPriceToShow()}
      </div>
      <div className='btn-details-holder'>
        <BtnSubmit text='לפרטים ורכישה' />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {showPackageDetails, goToPage, reportAnalytics, setSubscriptionPriceForDisplay};

export default connect(mapStateToProps, mapDispatchToProps)(premiumPackage);
